import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { translations } from './translations';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguageState] = useState(() => {
    const saved = localStorage.getItem('respiro_blu_language');
    if (saved && ['it', 'en', 'es', 'hr'].includes(saved)) {
      return saved;
    }
    const browserLang = navigator.language?.slice(0, 2) || 'it';
    if (['it', 'en', 'es', 'hr'].includes(browserLang)) {
      return browserLang;
    }
    return 'it';
  });

  const [translationCache, setTranslationCache] = useState({});

  useEffect(() => {
    localStorage.setItem('respiro_blu_language', language);
    document.documentElement.lang = language;
  }, [language]);

  // Funzione per ottenere una traduzione statica
  const t = useCallback((key) => {
    const keys = key.split('.');
    let value = translations[language];
    
    for (const k of keys) {
      if (value && typeof value === 'object') {
        value = value[k];
      } else {
        // Fallback all'italiano
        let fallback = translations['it'];
        for (const fk of keys) {
          if (fallback && typeof fallback === 'object') {
            fallback = fallback[fk];
          }
        }
        return fallback || key;
      }
    }
    
    return value || key;
  }, [language]);

  // Cambia lingua
  const setLanguage = useCallback((lang) => {
    if (['it', 'en', 'es', 'hr'].includes(lang)) {
      setLanguageState(lang);
      // Forza re-render pulendo la cache
      setTranslationCache({});
    }
  }, []);

  const languages = [
    { code: 'it', name: 'Italiano', flag: '🇮🇹' },
    { code: 'en', name: 'English', flag: '🇬🇧' },
    { code: 'es', name: 'Español', flag: '🇪🇸' },
    { code: 'hr', name: 'Hrvatski', flag: '🇭🇷' }
  ];

  // Valore del context con key che forza re-render
  const value = {
    language,
    setLanguage,
    t,
    languages,
    translations: translations[language],
    key: language // Forza re-render quando cambia
  };

  return (
    <LanguageContext.Provider value={value} key={language}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageProvider;
